import { render } from "./ActionIcons.vue?vue&type=template&id=cea41c8e&ts=true"
import script from "./ActionIcons.vue?vue&type=script&lang=ts"
export * from "./ActionIcons.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3205782090/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__